import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'g10-ms-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  @Output('onAction') emitter = new EventEmitter();
  @Output('pageAction') pageEmitter = new EventEmitter();
  @Input('data') data = [];
  @Input('cols') tableCols = [];
  @Input('filter') filter: boolean;
  @Input('height') tableHeight = '60vh';
  @Input('showPagination') isPagination = false;
  @Input('paginationData') paginationData;
  @Input('class') tableClass = '';


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public pageNumber = 1;
  public pageLimit = '10';

  // store dataSource as material Table data source for filter options  
  public dataSource: any;
  public searchValue = '';
  constructor() { }
  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data);
  }
  ngOnChanges(changes: OnChanges) {
    if (changes['paginationData']) {
      if (this.paginationData['page']) this.pageNumber = this.paginationData['page'];
      if (this.paginationData['limit']) this.pageLimit = String(this.paginationData['limit']);
    }
    if (changes['data']) {
      this.dataSource = new MatTableDataSource(this.data);
    }
  }

  capitalizeWords(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // We will need this getter to exctract keys from tableCols
  get keys() {
    return this.tableCols.map(({ key }) => key);
  }
  isNumber(o): boolean {
    return !isNaN(o - 0) && o !== null && o !== '' && o !== false;
  }
  // this function will return a value from column configuration
  // depending on the value that element holds
  showBooleanValue(elt, column) {
    return column.config.values[`${elt[column.key]}`];
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  checkUserImage(data, user) {
    if (Array.isArray(data)) {
      if (data.includes(user)) return true;
      else return false;
    }
    else {
      if (data == user) return true;
      else return false;
    }
  }

  pagination(type) {
    if (type == 'next') {

      this.pageNumber++;

    } else if (type == 'prev') {
      if (this.pageNumber <= 1) return;
      this.pageNumber--;
    }
    this.pageEmitter.emit({ page: this.pageNumber, limit: Number(this.pageLimit) });
  }

  paginationLimit() {
    this.pageNumber = 1;
    this.pageEmitter.emit({ page: this.pageNumber, limit: Number(this.pageLimit) });
  }

  emitAction(action, element) {
  //   console.log("actionssssss", action, element)
  //   if (action == 'route') {
  //  action =   {
  //       "display": "View",
  //         "color": "primary",
  //           "icon": "View"
  //     }
  //   }

    this.emitter.emit({ action: action, data: element })
  }

}
